/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-20T12:07:15.716
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'systemmanage-OrgUserManage-'

export default 
{
path: '/systemmanage/orgusermanage',
name: 'systemmanage-OrgUserManage',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}OrgUserManage-index',

meta:{
...meta,
title: '用户管理'
},

component: () => import('@/pages/systemmanage/orgusermanage/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}OrgUserManage-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '用户管理编辑'
},

component: () => import('@/pages/systemmanage/orgusermanage/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}OrgUserManagedetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '用户管理新增'
},

component: () => import('@/pages/systemmanage/orgusermanage/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}OrgUserManageView',
auth: [
'hidden'
],

meta:{
...meta,
title: '用户管理详情查看'
},

component: () => import('@/pages/systemmanage/orgusermanage/detail-view') ,
},
]
};
